import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { AxiosError } from "axios";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { exportTranslation } from "../../api/exportTranslation";

export function useExportTranslation() {
  return useMutation({
    mutationFn: exportTranslation,
    onSuccess: ({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      toast.success("Translation exported successfully");
    },
    onError: (error: AxiosError) => {
      const errorMessage = ErrorUtils.getErrorMessage(error);
      toast.error(errorMessage, {
        autoClose: false,
      });
    },
  });
}
